import * as Yup from 'yup';

export type TFormFieldNames = "channel_name" | "selected_users";

export const createNewGroupChatInitialValues = {
  channel_name: '',
  selected_users: [] as string[] | {label:string , value:string}[],
}

export const createNewGroupChatValidationSchema = Yup.object().shape({
  channel_name: Yup.string().required('Please enter a channel name'),
  // min 2 users required to create a group chat
  selected_users: Yup.array().of(Yup.object().required('Please select at least one user')).min(2, 'Please select at least 2 users'),
});

export type TFormFieldNamesSMS = "selected_users" | "sms_message";

export const createNewGroupSMSInitialValues = {
  selected_users: [] as string[] | {label:string , value:string}[],
  sms_message: '',
}

export const createNewGroupSMSValidationSchema = Yup.object().shape({
  selected_users: Yup.array().of(Yup.object().required('Please select at least one user')),
  sms_message: Yup.string().required('Please enter a message'),
});